export const GET_SELLER_PRODUCT_REQUEST = "GET_SELLER_PRODUCT_REQUEST";
export const GET_SELLER_PRODUCT_SUCCESS = "GET_SELLER_PRODUCT_SUCCESS";
export const GET_SELLER_PRODUCT_FAILED = "GET_SELLER_PRODUCT_FAILED";

export const DELETE_SELLER_PRODUCT_SUCCESS = "DELETE_SELLER_PRODUCT_SUCCESS";

export const UPDATE_sELLER_PRODUCT_SUCCESS = "UPDATE_sELLER_PRODUCT_SUCCESS";